export class PageUtils {
    // Function that lets you provide a list of classes to toggle at the same time
    // e.g. superToggle(myElement, ['opacity-0', '-translate-y-full']);
    static superToggle(element, classes) {
        for (let CLASS of classes) {
            element.classList.toggle(CLASS);
        }
    }

    // Used to smooth scroll to target, able to set offset if required (e.g. navigation is fixed)
    static scrollToTarget(element){
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }

    // Useful for when a modal is open to prevent scrolling in the background
    static bodyLockToggle() {
        const doc = document.documentElement;
        const docBody = document.body;
        if (!docBody.classList.contains('fixed')) {
            this.bodyLockToggleOn();
        } else {
            this.bodyLockToggleOff();
        }
    }

    static bodyLockToggleOn() {
        const docBody = document.body;
        docBody.style.top = `-${window.scrollY}px`;
        docBody.classList.add('fixed');

        // Hide scroll-to-top button when body is locked
        const scrollCta = document.querySelector('button[data-scroll-cta]');
        if (scrollCta) {
            scrollCta.classList.add('hidden');
        }
    }

    static bodyLockToggleOff() {
        const doc = document.documentElement;
        const docBody = document.body;
        const scrollYPosition = docBody.style.top;
        docBody.style.top = '';
        docBody.classList.remove('fixed');
        doc.style.scrollBehavior = 'auto';
        window.scrollTo(0, parseInt(scrollYPosition || '0') * -1);
        doc.style.scrollBehavior = 'smooth';

        // Show scroll-to-top button when body is unlocked
        const scrollCta = document.querySelector('button[data-scroll-cta]');
        if (scrollCta) {
            scrollCta.classList.remove('hidden');
        }
    }

    static #copyToClipboardDeprecated(value) {
        // Deprecated method here exists as a fallback pathway
        let temp = document.createElement('textarea');
        temp.value = value;
        document.body.appendChild(temp);
        temp.select();
        document.execCommand('copy');
        document.body.removeChild(temp);
    }

    // Copy content to Clipboard
    static copyToClipboard(value) {
        if (!navigator.clipboard || !navigator.permissions || (window.location.protocol === 'http:' && window.location.hostname !== 'localhost')) {
            // Use the deprecated method if we are in a browser that doesnt support the clipboard API
            // Also, clipboard API only works on HTTPS except for 'localhost' which works on HTTP
            this.#copyToClipboardDeprecated(value);

            return new Promise((resolve,reject) => {
                resolve();
            });
        } else {
            //
            return navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
                if (result.state === "granted" || result.state === "prompt") {
                    return navigator.clipboard.writeText(value);
                }

                throw new Error('No access to clipboard');
            }).catch((err) => {
                // If we had an error using the clipboard api, lets try fall-back to the deprecated method
                return this.#copyToClipboardDeprecated(value);
            })
        }
    }

    static zoom(event) {
        if (event) {
            const zoomer = event.currentTarget;
            const parent = zoomer.parentElement;
            let multiplier = parseInt(zoomer.dataset.zoom) || 0; // Default to 0 if not set
            zoomer.style.backgroundRepeat = 'no-repeat';

            function initZoom() {
                if (multiplier === 0) {
                    zoomer.style.backgroundSize = 'contain';
                    zoomer.style.backgroundPosition = 'center';
                    zoomer.style.cursor = 'zoom-in';
                    parent.classList.add('relative');
                } else {
                    const offsetX = event.offsetX ? event.offsetX : event.touches[0].pageX;
                    const offsetY = event.offsetY ? event.offsetY : event.touches[0].pageY;
                    const x = (offsetX / zoomer.offsetWidth) * 100;
                    const y = (offsetY / zoomer.offsetHeight) * 100;
                    zoomer.style.backgroundSize = multiplier === 1 ? '150%' : '200%';
                    zoomer.style.backgroundPosition = `${x}% ${y}%`;
                    parent.classList.remove('relative');
                }
            }
            initZoom();

            zoomer.onclick = () => {
                if (multiplier === 1) {
                    multiplier = 2;
                } else if (multiplier === 2) {
                    multiplier = 0;
                } else {
                    multiplier = 1;
                }
                zoomer.dataset.zoom = multiplier;
                zoomer.style.cursor = multiplier === 2 ? 'zoom-out' : 'zoom-in';
                initZoom();
            };
        }
    }

}